import { useMemo } from 'react';
import { Location, NavLink } from 'react-router-dom';

import { CustomIcon } from '~components/index';

interface SidebarItemProps {
  data: Sidebar;
  location: Location;
}
const SidebarItem = ({ data, location }: SidebarItemProps) => {
  const style = useMemo(() => {
    if (data.parameters) {
      return (
        `/platform/${data.functional_name}${location.search}` ===
        `${location.pathname}?${data.parameters}`
      );
    } else return `/platform/${data.functional_name}` === location.pathname;
  }, [location]);

  return (
    <NavLink
      className={`sidebar_link ${style ? 'sidebar_link_active' : ''}`}
      to={
        !data.parameters
          ? `/platform/${data.functional_name}`
          : `/platform/${data.functional_name}?${data.parameters}`
      }
    >
      <CustomIcon name={data.icon || 'FaCircle'} />
      <p className="text-break ms-2">{data.label}</p>
    </NavLink>
  );
};

export default SidebarItem;
